"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureDebug = void 0;
const api_1 = require("@opentelemetry/api");
const util_1 = require("./util");
const validate_options_1 = require("./validate-options");
/**
 * Configures the Honeycomb Web SDK to log debug information to the console.
 * Enables the DiagConsoleLogger and sets the log level to DEBUG.
 * Logs the provided Honeycomb options to the console, as well as defaults.
 *
 * @param options the provided Honeycomb options
 */
function configureDebug(options) {
    if (!(options === null || options === void 0 ? void 0 : options.debug)) {
        return;
    }
    api_1.diag.setLogger(new api_1.DiagConsoleLogger(), api_1.DiagLogLevel.DEBUG);
    api_1.diag.debug((0, util_1.createHoneycombSDKLogMessage)('🐝 Honeycomb Web SDK Debug Mode Enabled 🐝'));
    // traces endpoint must be computed from provided options
    const tracesEndpoint = (0, util_1.getTracesEndpoint)(options);
    const currentOptions = Object.assign(Object.assign(Object.assign({}, util_1.defaultOptions), options), { tracesEndpoint });
    debugTracesApiKey(currentOptions);
    debugServiceName(currentOptions);
    debugTracesEndpoint(currentOptions);
    debugSampleRate(currentOptions);
}
exports.configureDebug = configureDebug;
function debugTracesApiKey(options) {
    const tracesApiKey = (0, util_1.getTracesApiKey)(options) || '';
    if (!tracesApiKey) {
        api_1.diag.debug(validate_options_1.MISSING_API_KEY_ERROR);
        return;
    }
    api_1.diag.debug((0, util_1.createHoneycombSDKLogMessage)(`API Key configured for traces: '${tracesApiKey}'`));
}
function debugServiceName(options) {
    const serviceName = options.serviceName || util_1.defaultOptions.serviceName;
    if (serviceName === util_1.defaultOptions.serviceName) {
        api_1.diag.debug(validate_options_1.MISSING_SERVICE_NAME_ERROR);
        return;
    }
    api_1.diag.debug(`@honeycombio/opentelemetry-web: Service Name configured for traces: '${serviceName}'`);
}
function debugTracesEndpoint(options) {
    const tracesEndpoint = (0, util_1.getTracesEndpoint)(options);
    if (!tracesEndpoint) {
        api_1.diag.debug((0, util_1.createHoneycombSDKLogMessage)('No endpoint configured for traces'));
        return;
    }
    api_1.diag.debug((0, util_1.createHoneycombSDKLogMessage)(`Endpoint configured for traces: '${tracesEndpoint}'`));
}
function debugSampleRate(options) {
    const sampleRate = (0, util_1.getSampleRate)(options);
    if (!sampleRate) {
        // this should never happen, but guard just in case?
        api_1.diag.debug('No sampler configured for traces');
        return;
    }
    api_1.diag.debug((0, util_1.createHoneycombSDKLogMessage)(`Sample Rate configured for traces: '${sampleRate}'`));
}
